import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  // const RCSelectionChange = listeners["selection-change"] || function () { };

  const deleteNode = listeners["deleteNode"] || function () { };
  const editNode = listeners["editNode"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let dealConf = [
      ["icon-edit", "编辑", () => {editNode(vo.row)}, "auditNode:update"],
      ["icon-delete", "删除", () => deleteNode(vo.row), "auditNode:delete"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  function selectable(row, index) {
    if (row.auditStatus == 0) {
      return true
    }
    return false
  }

  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main",
    //   selectable: selectable
    // },
    {
      label: "审核节点",
      prop: "deptName",
      minWidth: "100",
    }, {
      label: "审核人姓名",
      prop: "auditUserName",
      minWidth: " 90",
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "可审核管理主体",
      prop: "leaderTypeNames",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "60",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        // onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
